export interface OctopusTextTheme {
    "fontFamilyCode": string;
    "fontFamilyDefault": string;
    "textBodyBoldLarge": string;
    "textBodyBoldMedium": string;
    "textBodyBoldSmall": string;
    "textBodyBoldXSmall": string;
    "textBodyRegularLarge": string;
    "textBodyRegularMedium": string;
    "textBodyRegularSmall": string;
    "textBodyRegularXSmall": string;
    "textCodeBoldLarge": string;
    "textCodeBoldMedium": string;
    "textCodeBoldSmall": string;
    "textCodeBoldXSmall": string;
    "textCodeRegularLarge": string;
    "textCodeRegularMedium": string;
    "textCodeRegularSmall": string;
    "textCodeRegularXSmall": string;
    "textHeading2xLarge": string;
    "textHeadingLarge": string;
    "textHeadingMedium": string;
    "textHeadingSmall": string;
    "textHeadingXLarge": string;
    "textHeadingXSmall": string;
}